import type { FilterSchema } from '@/shared/components/filter/validation'
import type { FilterRuleEntity } from '@/shared/components/query-builder'

import { useMemo } from 'react'
import { ListFilterIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import FiltersPopover from '@/shared/components/filter/FiltersPopover'
import SearchField from '@/shared/components/SearchField'
import { Button } from '@/shared/components/ui/button'
import { useLocationQuery } from '@/shared/hooks/useLocationQuery'
import { ampli } from '@/shared/lib/ampli'

import { getFilterFields } from '../../lib/helpers'
import { useApprovalTableDataChoices } from '../../lib/useApprovalTableDataChoices'

export default function ApprovalTableToolbar() {
	const { t } = useTranslation()

	const [{ search: searchText, filters }, setQuery] = useLocationQuery()
	const filterFields = useMemo(() => getFilterFields(t), [t])
	const dataChoices = useApprovalTableDataChoices()
	const handleApplyFilter = (filters: FilterRuleEntity[]) => {
		ampli.tableAnchorApprovalApplyFilter()
		setQuery({ filters: filters?.length ? filters : null })
	}

	return (
		<div className='flex items-center space-x-2'>
			<SearchField
				data-testid='search-field'
				onValueChange={(search) => setQuery({ search })}
				value={searchText}
				placeholder={t('general_search')}
			/>
			<FiltersPopover
				fields={filterFields}
				onApply={handleApplyFilter}
				dataChoices={dataChoices}
				filters={(filters as FilterSchema[]) || []}
			>
				<Button>
					<ListFilterIcon />
					{t('general_filter')}&nbsp;
					{filters.length ? `(${filters.length})` : ''}
				</Button>
			</FiltersPopover>
		</div>
	)
}
